<template>
	<div
		v-if="items.length"
		v-click-outside="closeLangNav"
		class="lang-select"
		@mouseenter="showLangNav = true"
		@mouseleave="showLangNav = false"
		@click="toggleLangNav"
	>
		<span>{{ locale }}&nbsp;</span>
		<font-awesome-icon :class="{ rotated: showLangNav }" icon="fa-sharp fa-regular fa-chevron-down" size="1x" />
		<transition name="lang-wrapper-fade">
			<div v-if="showLangNav" class="lang-wrapper">
				<div
					v-for="item in items.filter((i) => i.language !== locale)"
					:key="`${item.filename}-${item.language}`"
				>
					<nuxt-link class="lang-item" :class="item.language" :to="`${item.filename}`" @click="hideMenu">
						{{ item.language }}
					</nuxt-link>
				</div>
			</div>
		</transition>
	</div>
</template>

<script setup>
const { locale } = useI18n();

defineProps({
	items: { type: Array, default: () => [] },
});

const showLangNav = ref(false);

const toggleLangNav = () => {
	showLangNav.value = !showLangNav.value;
};

const closeLangNav = () => {
	showLangNav.value = false;
};
</script>

<style lang="scss" scoped>
.lang-wrapper-fade-enter-active,
.lang-wrapper-fade-leave-active {
	transition:
		opacity 0.6s ease-in-out,
		transform 0.4s ease-out;
}

.lang-wrapper-fade-enter-from,
.lang-wrapper-fade-leave-to {
	opacity: 0;
	transform: translateY(-20px) scaleY(0.8);
}

.lang-wrapper-fade-enter-to,
.lang-wrapper-fade-leave-from {
	opacity: 1;
	transform: translateY(0) scaleY(1);
}

.rotated {
	transform: rotate(-180deg);
	transition: transform 0.4s ease-out;
}

.lang-select {
	max-width: 75px;
	padding: 12px 10px;
	cursor: pointer;
	position: relative;
	text-transform: uppercase;
	display: flex;
	align-items: center;

	i {
		font-size: 12px;
	}
}

.lang-wrapper {
	position: absolute;
	top: 35px;
	left: 3px;
	right: 3px;
	padding: 10px 9px;
	text-align: center;
	background: #fff;
	box-shadow: 0 18px 18px rgb(0 0 0 / 10%);
	border-radius: 3px;
	z-index: 90;

	div {
		margin-bottom: 5px;
	}
}

.lang-wrapper.active,
.lang-wrapper a {
	display: flex;
	flex-flow: column nowrap;
	align-items: center;
	place-content: center;
	color: #444;

	&:hover {
		color: #000;
	}
}

.lang-wrapper a {
	width: 100%;
	flex-direction: row;
}

.lang-wrapper img {
	width: 16px;
	height: 16px;
	margin: 2px 0 0;
}
</style>
